import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-64a00546")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "Step 2", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", null, "Selected source:", -1)
const _hoisted_3 = { class: "split" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Current order:")
], -1)
const _hoisted_5 = { class: "right buttons" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlaylistCard = _resolveComponent("PlaylistCard")!
  const _component_TrackList = _resolveComponent("TrackList")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createVNode(_component_PlaylistCard, { source: _ctx.selectedSource }, null, 8, ["source"]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.shuffle && _ctx.shuffle(...args)))
        }, "Preview shuffle"),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
        }, "Save")
      ])
    ]),
    _createVNode(_component_TrackList, { tracks: _ctx.tracks }, null, 8, ["tracks"])
  ], 64))
}